import { ContentType, ModalConstants, PagePart, Step } from 'app/modules/step-engine/utils/step-engine-constants';
import { CmsContentType, CmsPageContentType } from './cms-constants';

export const CmsContentTypeMap = new Map([
  [ContentType.LEGAL_NOTICE, CmsContentType.LEGAL_NOTICE],
  [ContentType.TERMS_OF_SERVICE, CmsContentType.TERMS_OF_SERVICE],
  [ContentType.PRIVACY_POLICY, CmsContentType.PRIVACY_POLICY],
]);

export const CmsPagePartMap = new Map([
  [PagePart.APP_GLOBAL_TYPE, CmsPageContentType.APP_GLOBAL_TYPE],
  [PagePart.POP_IN, CmsPageContentType.POP_IN],
  [PagePart.CONTRACT_DOCUMENTS, CmsPageContentType.CONTRACT_DOCUMENTS],
  [PagePart.GENERIC_SIDE_NAV_PDV, CmsPageContentType.GENERIC_SIDE_NAV_PDV],
]);

export const CmsModalContentMap = new Map([
  [ModalConstants.INVALID_DAMAGED_GOOD, CmsPageContentType.KUBRICK_INVALID_DAMAGED_GOOD],
  [ModalConstants.DECLARATION_CANNOT_BE_REGISTERED, CmsPageContentType.KUBRICK_DECLARATION_CANNOT_BE_REGISTERED],
  [ModalConstants.VOUCHER_GENERATION_CONFIRMATION, CmsPageContentType.KUBRICK_VOUCHER_GENERATION_CONFIRMATION],
  [ModalConstants.RECLAMATION_TO_MERCHANT, CmsPageContentType.KUBRICK_RECLAMATION_TO_MERCHANT],
  [ModalConstants.OVERTAKING_DATE, CmsPageContentType.KUBRICK_OVERTAKING_DATE],
  [ModalConstants.HAVE_IN_PROGRESS_CLAIM, CmsPageContentType.KUBRICK_HAVE_IN_PROGRESS_CLAIM],
  [ModalConstants.CARD_ELIGIBILITY_MODAL, CmsPageContentType.KUBRICK_CARD_ELIGIBILITY_MODAL],
  [ModalConstants.MULTI_CLAIM_MODAL, CmsPageContentType.KUBRICK_MULTI_CLAIM_MODAL],
  [ModalConstants.BIN_ELIGIBILITY_MODAL, CmsPageContentType.KUBRICK_BIN_ELIGIBILITY_MODAL],
  [ModalConstants.COVER_ELIGIBILITY_MODAL, CmsPageContentType.KUBRICK_COVER_ELIGIBILITY_MODAL],
  [ModalConstants.OUT_OF_WARRANTY, CmsPageContentType.KUBRICK_OUT_OF_WARRANTY],
]);

export const CmsPageContentMap = new Map([
  [Step.JOURNEY_HOME_PAGE, CmsPageContentType.KUBRICK_JOURNEY_HOME_PAGE],
  [Step.LOADING_LAYOUT_CONTENT, CmsPageContentType.LOADING_LAYOUT_CONTENT],
  [Step.PARKOUR_CLIENT_DETAILS_CONFIRMATION, CmsPageContentType.PARKOUR_CLIENT_DETAILS_CONFIRMATION],
  [Step.DAMAGED_GOOD_USER_CREATION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_USER_CREATION],
  [Step.DAMAGED_GOOD_CREATION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_CREATION],
  [Step.DAMAGED_GOOD_FAMILY, CmsPageContentType.KUBRICK_DAMAGED_GOOD_FAMILY],
  [Step.DAMAGED_GOOD_DATE, CmsPageContentType.KUBRICK_DAMAGED_GOOD_DATE],
  [Step.DAMAGED_GOOD_IMEI_VALIDATION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_IMEI_VALIDATION],
  [Step.REFERENTIAL_ITEMS, CmsPageContentType.REFERENTIAL_ITEMS],
  [Step.SUPPORTING_DOCUMENTS, CmsPageContentType.KUBRICK_INFORMATION_FOR_SUPPORTING_DOCUMENTS],
  [Step.DAMAGED_GOOD_SERIAL_NUMBER_VALIDATION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_SERIAL_NUMBER_VALIDATION],
  [Step.DAMAGED_GOOD_SELECTION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_SELECTION],
  [Step.CLAIM_LOCATION, CmsPageContentType.KUBRICK_CLAIM_LOCATION],
  [Step.UPLOAD_DECLARATION, CmsPageContentType.KUBRICK_UPLOAD_DECLARATION],
  [Step.DAMAGED_GOOD_USER_CONFIRMATION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_USER_CONFIRMATION],
  [Step.CLAIM_TRIGGER_NATURE, CmsPageContentType.KUBRICK_CLAIM_TRIGGER_NATURE],
  [Step.EXTERNAL_DAMAGE_CONFIRMATION, CmsPageContentType.KUBRICK_EXTERNAL_DAMAGE_CONFIRMATION],
  [Step.CLAIM_RESULT_SELECTION, CmsPageContentType.KUBRICK_CLAIM_RESULT_SELECTION],
  [Step.CHOOSE_DAMAGED_GOODS, CmsPageContentType.KUBRICK_CHOOSE_DAMAGED_GOODS],
  [Step.CLAIM_RESULT_FREE_ENTRY, CmsPageContentType.KUBRICK_CLAIM_RESULT_FREE_ENTRY],
  [Step.DAMAGED_GOOD_DYSFUNCTION_SELECTION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_DYSFUNCTION_SELECTION],
  [Step.DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY, CmsPageContentType.KUBRICK_DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY],
  [Step.DAMAGED_GOOD_CIRCONSTANCES, CmsPageContentType.KUBRICK_DAMAGED_GOOD_CIRCONSTANCES],
  [Step.DAMAGED_GOOD_ACCESSORIES_VALIDATION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_ACCESSORIES_VALIDATION],
  [Step.DECLARATION_SUMMARY, CmsPageContentType.KUBRICK_DECLARATION_SUMMARY],
  [Step.CLIENT_DETAILS_CONFIRMATION, CmsPageContentType.KUBRICK_CLIENT_DETAILS_CONFIRMATION],
  [Step.IMPROVEMENT_QUALITY, CmsPageContentType.KUBRICK_IMPROVEMENT_QUALITY],
  [Step.UPDATE_CLIENT_DETAILS, CmsPageContentType.KUBRICK_UPDATE_CLIENT_DETAILS],
  [Step.DECLARATION_CONFIRMATION, CmsPageContentType.KUBRICK_DECLARATION_CONFIRMATION],
  [Step.COVER_SELECTION, CmsPageContentType.KUBRICK_COVER_SELECTION],
  [Step.CONTACT_MODE, CmsPageContentType.KUBRICK_CONTACT_MODE],
  [Step.CONTACT_FORM, CmsPageContentType.KUBRICK_CONTACT_FORM],
  [Step.CLAIM_DECLARE_CONTACT_FORM, CmsPageContentType.KUBRICK_CLAIM_DECLARE_CONTACT_FORM],
  [Step.CONFIRM_EMAIL, CmsPageContentType.KUBRICK_CONFIRM_EMAIL],
  [Step.NEED_HELP, CmsPageContentType.KUBRICK_NEED_HELP],
  [Step.TRAVEL_ASSISTANCE, CmsPageContentType.KUBRICK_TRAVEL_ASSISTANCE],
  [Step.DAMAGED_GOOD_PROPER_USE_CONFIRMATION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_PROPER_USE_CONFIRMATION],
  [Step.OTHER_CLAIM_TRIGGER_NATURE, CmsPageContentType.KUBRICK_OTHER_CLAIM_TRIGGER_NATURE],
  [Step.DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION],
  [Step.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION, CmsPageContentType.KUBRICK_DEVICE_DOES_NOT_TURN_ON_CONFIRMATION],
  [Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION, CmsPageContentType.KUBRICK_DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION],
  [Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE, CmsPageContentType.KUBRICK_DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE],
  [Step.DAMAGE_OBSERVED_FREE_ENTRY, CmsPageContentType.KUBRICK_DAMAGE_OBSERVED_FREE_ENTRY],
  [Step.STOLEN_TYPE_SELECTION, CmsPageContentType.KUBRICK_STOLEN_TYPE_SELECTION],
  [Step.PHYSICAL_VIOLENCE_CONFORMATION, CmsPageContentType.KUBRICK_PHYSICAL_VIOLENCE_CONFIRMATION],
  [Step.THEFT_INSURED_PERSON_ELIGIBILITY, CmsPageContentType.KUBRICK_THEFT_INSURED_PERSON_ELIGIBILITY],
  [Step.THEFT_PLACE_SELECTION, CmsPageContentType.KUBRICK_THEFT_PLACE_SELECTION],
  [Step.THEFT_ADDRESS_VALIDATION, CmsPageContentType.KUBRICK_THEFT_ADDRESS_VALIDATION],
  [Step.THEFT_ACCESSORIES_VALIDATION, CmsPageContentType.KUBRICK_THEFT_ACCESSORIES_VALIDATION],
  [Step.THEFT_POLICE_REPORT_CONFIRMATION, CmsPageContentType.KUBRICK_THEFT_POLICE_REPORT_CONFIRMATION],
  [Step.DEVICE_SIM_CARD_IN_OPPOSITION_CONFIRMATION, CmsPageContentType.KUBRICK_DEVICE_SIM_CARD_IN_OPPOSITION_CONFIRMATION],
  [Step.REMPLACEMENT_DEVICE_NEW_SIM_REQUEST, CmsPageContentType.KUBRICK_REMPLACEMENT_DEVICE_NEW_SIM_REQUEST],
  [Step.BURGLARY_DEVICE_SELECTION, CmsPageContentType.KUBRICK_BURGLARY_DEVICE_SELECTION],
  [Step.BURGLARY_LOCATION_ACTIVE_CONFIRMATION, CmsPageContentType.KUBRICK_BURGLARY_LOCATION_ACTIVE_CONFIRMATION],
  [Step.EXTERNAL_PRODUCT_VISIBLE_CONFIRMATION, CmsPageContentType.KUBRICK_EXTERNAL_PRODUCT_VISIBLE_CONFIRMATION],
  [Step.CLANDESTINE_INTRODUCTION_PLACE_SELECTION, CmsPageContentType.KUBRICK_CLANDESTINE_INTRODUCTION_PLACE_SELECTION],
  [
    Step.INTRODUCTION_CLANDESTINE_PLACE_OCCUPIED_CONFIRMATION,
    CmsPageContentType.KUBRICK_INTRODUCTION_CLANDESTINE_PLACE_OCCUPIED_CONFIRMATION,
  ],
  [Step.PRODUCT_IN_HAND_CONFIRMATION, CmsPageContentType.KUBRICK_PRODUCT_IN_HAND_CONFIRMATION],
  [Step.PRODUCT_IN_BAG_CONFIRMATION, CmsPageContentType.KUBRICK_PRODUCT_IN_BAG_CONFIRMATION],
  [Step.PRODUCT_IN_POCKET_CONFIRMATION, CmsPageContentType.KUBRICK_PRODUCT_IN_POCKET_CONFIRMATION],
  [Step.BENEFIT_TYPE_SELECTION, CmsPageContentType.KUBRICK_BENEFIT_TYPE_SELECTION],
  [Step.BENEFIT_DEPOSIT_METHOD, CmsPageContentType.KUBRICK_BENEFIT_DEPOSIT_METHOD],
  [Step.DEVICE_PATTERN_LOCK, CmsPageContentType.KUBRICK_DEVICE_PATTERN_LOCK],
  [Step.REGISTERED_STATEMENT, CmsPageContentType.KUBRICK_REGISTERED_STATEMENT],
  [Step.CONFIRMED_DECLARATION, CmsPageContentType.KUBRICK_CONFIRMED_DECLARATION],
  [Step.TRANSPORT_VOUCHER_GENERATION_VALIDATION, CmsPageContentType.KUBRICK_TRANSPORT_VOUCHER_GENERATION_VALIDATION],
  [Step.TRANSPORT_VOUCHER_GENERATION_INFORMATION, CmsPageContentType.KUBRICK_TRANSPORT_VOUCHER_GENERATION_INFORMATION],
  [Step.UPDATE_BENEFIT_ADDRESS_DETAILS, CmsPageContentType.KUBRICK_UPDATE_BENEFIT_ADDRESS_DETAILS],
  [Step.INSTRUCTIONS_FOR_PACKING, CmsPageContentType.KUBRICK_INSTRUCTIONS_FOR_PACKING],
  [Step.TRANSPORT_VOUCHER_GENERATION, CmsPageContentType.KUBRICK_TRANSPORT_VOUCHER_GENERATION],
  [Step.BENEFIT_INFORMATIVE_MESSAGE_DATA_SECURITY, CmsPageContentType.KUBRICK_BENEFIT_INFORMATIVE_MESSAGE_DATA_SECURITY],
  [Step.REGISTERED_STATEMENT_WITH_ANNOUNCEMENT, CmsPageContentType.KUBRICK_REGISTERED_STATEMENT_WITH_ANNOUNCEMENT],
  [Step.BENEFIT_POINT_SELECTION, CmsPageContentType.KUBRICK_BENEFIT_POINT_SELECTION],
  [Step.BENEFIT_CHOSEN_RELAY_POINT_VALIDATION, CmsPageContentType.KUBRICK_BENEFIT_CHOSEN_RELAY_POINT_VALIDATION],
  [Step.BENEFIT_CHOSEN_PROXIMITY_POINT_VALIDATION, CmsPageContentType.KUBRICK_BENEFIT_CHOSEN_PROXIMITY_POINT_VALIDATION],
  [Step.INSTRUCTIONS_FOR_DEACTIVATING_FIND_MY_IPHONE, CmsPageContentType.KUBRICK_INSTRUCTIONS_FOR_DEACTIVATING_FIND_MY_IPHONE],
  [Step.DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION, CmsPageContentType.KUBRICK_DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION],
  [Step.CLAIM_LOCATION, CmsPageContentType.KUBRICK_CLAIM_LOCATION],
  [Step.CONTACT_MANAGEMENT_SERVICE, CmsPageContentType.KUBRICK_CONTACT_MANAGEMENT_SERVICE],
  [Step.DEADLINE_REMINDER_CONFIRMATION, CmsPageContentType.KUBRICK_DEADLINE_REMINDER_CONFIRMATION],
  [Step.COMPLAINED_TO_MERCHANT_CONFIRMATION, CmsPageContentType.KUBRICK_COMPLAINED_TO_MERCHANT_CONFIRMATION],
  [Step.CAPITAL_SHIPPING_ADDRESS_CONFIRMATION, CmsPageContentType.KUBRICK_CAPITAL_SHIPPING_ADDRESS_CONFIRMATION],
  [Step.CLAIM_DECLARATION_DATE, CmsPageContentType.KUBRICK_CLAIM_DECLARATION_DATE],
  [Step.CONCERNED_ELEMENT_SELECTION, CmsPageContentType.KUBRICK_CONCERNED_ELEMENT_SELECTION],
  [Step.COMPLAINED_TO_POLICE_REMINDER, CmsPageContentType.KUBRICK_COMPLAINED_TO_POLICE_REMINDER],
  [Step.EXTERNAL_REFERENCE, CmsPageContentType.KUBRICK_EXTERNAL_REFERENCE],
  [Step.RELATIONSHIP_TO_THE_VICTIM, CmsPageContentType.KUBRICK_RELATIONSHIP_TO_THE_VICTIM],
  [Step.CUSTOMER_INFORMATION, CmsPageContentType.KUBRICK_CUSTOMER_INFORMATION],
  [Step.ANOTHER_INSURER, CmsPageContentType.KUBRICK_ANOTHER_INSURER],
  [Step.DECLARE_ANOTHER_DAMAGE, CmsPageContentType.KUBRICK_DECLARE_ANOTHER_DAMAGE],
  [Step.CUSTOMER_CREDIT_CARD, CmsPageContentType.KUBRICK_CUSTOMER_CREDIT_CARD],
  [Step.DAMAGED_GOOD_TIME, CmsPageContentType.KUBRICK_DAMAGED_GOOD_TIME],
  [Step.CUSTOMER_SPECIFY_PROPERTY, CmsPageContentType.KUBRICK_CUSTOMER_SPECIFY_PROPERTY],
  [Step.CONDITION_OF_PROPERTY, CmsPageContentType.KUBRICK_CONDITION_OF_PROPERTY],
  [Step.CONCERNED_DAMAGED_GOOD, CmsPageContentType.KUBRICK_CONCERNED_DAMAGED_GOOD],
  [Step.DAMAGED_GOOD_PURCHASE_DATE, CmsPageContentType.KUBRIC_DAMAGED_GOOD_PURCHASE_DATE],
  [Step.METHOD_OF_PAYMENT_CONFIRMATION, CmsPageContentType.KUBRICK_METHOD_OF_PAYMENT_CONFIRMATION],
  [Step.PURCHASE_VALUE, CmsPageContentType.KUBRICK_PURCHASE_VALUE],
  [Step.CLAIM_DOCUMENT, CmsPageContentType.KUBRICK_CLAIM_DOCUMENT],
]);

/* eslint-disable complexity */
export const itemsMapper = (dataKey, items) => {
  const itemsResult = [];
  switch (dataKey) {
    case Step.JOURNEY_HOME_PAGE:
    case Step.COVER_SELECTION:
    case Step.DAMAGED_GOOD_IMEI_VALIDATION:
    case Step.CONDITION_OF_PROPERTY:
    case Step.ANOTHER_INSURER:
    case Step.CUSTOMER_CREDIT_CARD:
    case Step.DECLARE_ANOTHER_DAMAGE:
    case Step.DAMAGED_GOOD_SERIAL_NUMBER_VALIDATION:
    case Step.DAMAGED_GOOD_ACCESSORIES_VALIDATION:
    case Step.EXTERNAL_DAMAGE_CONFIRMATION:
    case Step.DAMAGED_GOOD_USER_CONFIRMATION:
    case Step.DAMAGED_GOOD_FAMILY:
    case Step.CLAIM_TRIGGER_NATURE:
    case Step.CLAIM_RESULT_SELECTION:
    case Step.CHOOSE_DAMAGED_GOODS:
    case Step.OTHER_CLAIM_TRIGGER_NATURE:
    case Step.DAMAGED_GOOD_PROPER_USE_CONFIRMATION:
    case Step.DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION:
    case Step.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION:
    case Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION:
    case Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE:
    case Step.PHYSICAL_VIOLENCE_CONFORMATION:
    case Step.THEFT_INSURED_PERSON_ELIGIBILITY:
    case Step.THEFT_ADDRESS_VALIDATION:
    case Step.THEFT_ACCESSORIES_VALIDATION:
    case Step.THEFT_POLICE_REPORT_CONFIRMATION:
    case Step.DEVICE_SIM_CARD_IN_OPPOSITION_CONFIRMATION:
    case Step.REMPLACEMENT_DEVICE_NEW_SIM_REQUEST:
    case Step.BURGLARY_DEVICE_SELECTION:
    case Step.BURGLARY_LOCATION_ACTIVE_CONFIRMATION:
    case Step.EXTERNAL_PRODUCT_VISIBLE_CONFIRMATION:
    case Step.CLANDESTINE_INTRODUCTION_PLACE_SELECTION:
    case Step.INTRODUCTION_CLANDESTINE_PLACE_OCCUPIED_CONFIRMATION:
    case Step.PRODUCT_IN_BAG_CONFIRMATION:
    case Step.PRODUCT_IN_HAND_CONFIRMATION:
    case Step.PRODUCT_IN_POCKET_CONFIRMATION:
    case Step.STOLEN_TYPE_SELECTION:
    case Step.DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION:
    case Step.CLAIM_LOCATION:
    case Step.COMPLAINED_TO_MERCHANT_CONFIRMATION:
    case Step.CAPITAL_SHIPPING_ADDRESS_CONFIRMATION:
    case Step.GET_FIRST_STEP:
    case Step.CONTACT_MODE:
    case Step.BENEFIT_TYPE_SELECTION:
    case Step.METHOD_OF_PAYMENT_CONFIRMATION:
    case Step.CUSTOMER_INFORMATION:
    case PagePart.GENERIC_SIDE_NAV_PDV:
      items?.map(item => {
        const elt = {
          code: item.code ? item.code?.value : item.value?.value,
          value: item.value?.value,
          label: item.label?.value,
          icon: item.icon?.url,
        };
        if (item.description) {
          elt['description'] = item.description?.value;
        }
        if (item.tooltip) {
          elt['tooltip'] = item.tooltip?.value;
        }
        if (item.help_button) {
          elt['helpButtonText'] = item.help_button?.value;
        }
        if (item.help_text) {
          elt['helpModalText'] = item.help_text?.value;
        }
        if (item.banner_top?.url) {
          elt['bannerTop'] = item.banner_top?.url;
        }
        itemsResult.push(elt);
      });
      break;
    case Step.DAMAGED_GOOD_DYSFUNCTION_SELECTION:
      items?.map(item => {
        const elt = {
          code: item.value?.value,
          label: item.label?.value,
          tooltip: item.tooltip?.value,
        };
        itemsResult.push(elt);
      });
      break;
    case Step.THEFT_PLACE_SELECTION:
      items?.map(item => {
        const elt = {
          code: item.value?.value,
          label: item.label?.value,
        };
        itemsResult.push(elt);
      });
      break;
    case Step.DAMAGED_GOOD_DATE:
    case Step.CLAIM_DECLARATION_DATE:
      items?.map(item => {
        const elt = {
          code: item.value?.value,
          value: '',
          label: item.label?.value,
          icon: item.icon?.url,
        };
        if (elt.code === '0') {
          elt['selectedDay'] = 1;
        } else if (elt.code === '1') {
          elt['selectedDay'] = 0;
        } else if (elt.code === '2') {
          elt['isChooseDate'] = true;
        }
        itemsResult.push(elt);
      });
      break;
    case Step.BENEFIT_DEPOSIT_METHOD: {
      items?.map(item => {
        const infos = [];
        item?.infos?.blocks?.map(block => {
          let text = String(block?.text);
          while (text.includes(' ')) {
            text = text.replace(' ', ' ');
          }
          infos.push(text);
        });
        const reparationInfos = [];
        item?.reparation_infos?.blocks?.map(block => {
          let text = String(block?.text);
          while (text.includes(' ')) {
            text = text.replace(' ', ' ');
          }
          reparationInfos.push(text);
        });
        const replacementInfos = [];
        item?.replacement_infos?.blocks?.map(block => {
          let text = String(block?.text);
          while (text.includes(' ')) {
            text = text.replace(' ', ' ');
          }
          replacementInfos.push(text);
        });
        const elt = {
          code: item.value?.value,
          value: item.value?.value,
          label: item.label?.value,
          reparationLabel: item.reparation_label?.value,
          replacementLabel: item.replacement_label?.value,
          icon: item.icon?.url,
          infos,
          reparationInfos,
          replacementInfos,
        };
        itemsResult.push(elt);
      });
      break;
    }
    case Step.INSTRUCTIONS_FOR_PACKING:
    case Step.INSTRUCTIONS_FOR_DEACTIVATING_FIND_MY_IPHONE:
      items?.map(item => {
        const elt = {
          text: item.text?.value,
          icon: item.icon?.url,
        };
        itemsResult.push(elt);
      });
      break;
    case Step.REGISTERED_STATEMENT_WITH_ANNOUNCEMENT:
      items?.map(item => {
        const elt = {
          label: item.label?.value,
        };
        itemsResult.push(elt);
      });
      break;
    case Step.CONCERNED_ELEMENT_SELECTION: {
      items?.map(item => {
        const values = [];
        item?.values?.blocks?.map(block => {
          let text = String(block?.text);
          while (text.includes(' ')) {
            text = text.replace(' ', ' ');
          }
          values.push(text);
        });
        const elt = {
          code: item.code?.value,
          label: item.label?.value,
          values,
        };
        itemsResult.push(elt);
      });
      break;
    }
    case Step.DECLARATION_SUMMARY:
      items?.map(item => {
        const elt = {
          textNotice: item.text_notice?.blocks.map(text => text.text),
          iconNotice: item.icon_notice?.url,
        };
        itemsResult.push(elt);
      });
      break;
    case Step.RELATIONSHIP_TO_THE_VICTIM:
      items?.map(item => {
        const elt = {
          value: item.value?.value,
          label: item.label?.value,
        };
        itemsResult.push(elt);
      });
      break;
    default:
      break;
  }
  if (itemsResult.length > 0) {
    return itemsResult;
  } else {
    return items;
  }
};
